import { Typography } from '@altibox/design-system-component-lib';
import { css, styled } from 'styled-components';

import { BuildingSelectCard } from 'app/components/building-select-card';
import { CustomerDebtAlert } from 'app/components/customer-debt-alert';
import { SingleUnitCard } from 'app/components/single-unit-card';
import { breakpointLargeTablet, breakpointTablet } from 'app/style/breakpoints';
import { colorGreyBackground } from 'app/style/colors';
import { spacing1, spacing12, spacing2, spacing3, spacing4, spacing5, spacing6, spacing9 } from 'app/style/spacing';
import { HomeGatewayUpgradeAlert } from 'app/components/home-gateway-upgrade-alert';

const baseAlertStyles = css`
    margin-top: ${spacing1};
    margin-bottom: ${spacing4};

    @media (min-width: ${breakpointTablet}) {
        margin-top: ${spacing2};
    }
`;

export const StyledContainer = styled.div`
    background-color: ${colorGreyBackground};
    padding-top: ${spacing4};
    padding-bottom: ${spacing9};
    margin-top: ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        padding-top: ${spacing5};
        padding-bottom: ${spacing12};
        margin-top: ${spacing4};
    }
`;

export const StyledTitle = styled(Typography)`
    text-align: center;
    margin-bottom: ${spacing2};
    margin-top: ${spacing5};

    @media (min-width: ${breakpointTablet}) {
        margin-bottom: ${spacing3};
    }
`;

export const StyledSingleUnitTitle = styled(Typography)`
    text-align: center;
    margin-bottom: ${spacing4};

    @media (min-width: ${breakpointTablet}) {
        margin-bottom: ${spacing6};
    }
`;

export const StyledSubTitle = styled(Typography)`
    text-align: center;
    margin-bottom: ${spacing3};

    @media (min-width: ${breakpointTablet}) {
        margin-bottom: ${spacing6};
    }
`;

export const StyledSingleUnitCard = styled(SingleUnitCard)`
    margin: 0 auto;
`;

export const StyledBuildingNote = styled(Typography)`
    padding-bottom: ${spacing3};
`;

export const StyledBuildingSelectCardContainer = styled.div`
    margin-bottom: ${spacing2};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    @media (min-width: ${breakpointLargeTablet}) {
        flex-direction: row;
    }
`;

export const StyledBuildingSelectCard = styled(BuildingSelectCard)`
    @media (min-width: ${breakpointLargeTablet}) {
        min-width: unset;
        flex-grow: 1;

        &:not(:first-child) {
            margin-left: ${spacing4};
        }
    }
`;

export const StyledCustomerDebtAlert = styled(CustomerDebtAlert)`
    ${baseAlertStyles}
`;

export const StyledHomeGatewayUpgradeAlert = styled(HomeGatewayUpgradeAlert)`
    ${baseAlertStyles}
`;
